import { Container } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';

function ParcelContainer() {
  return (
    <Container
      maxW={'768px'}
      minW={'320px'}
      w={'100%'}
      height={'100vh'}
      px={0}
      bg={'white'}>
      <Helmet>
        <title>운송장 등록 · 변경</title>
      </Helmet>
      {<Outlet />}
    </Container>
  );
}

export default ParcelContainer;
